// extracted by mini-css-extract-plugin
module.exports = {"attachmentWrapper":"Attachment_attachmentWrapper__2KXam"};